import { apiReturnPaginatedResults, apiReturnResults } from '../../../apiFactory/apiReturn';
import { Request } from '../../../common/api';
import {
    type ApiResult,
    type BaseParams,
    type CallParams,
    type CollectionChainType,
    type CompetitionCollection,
    type CompetitionCollectionPatchParams,
    type PaginatedResult,
    type PagingParams,
    type PatchParams,
} from '../../../common/structs';
import { links } from '../../../links';

type GetCollectionsParams = BaseParams<PagingParams>;
type UpdateCollectionsParams = CallParams<PatchParams<CompetitionCollectionPatchParams>> & {
    slug: string;
    chain: CollectionChainType;
};
export async function listCollections({
    ...params
}: GetCollectionsParams): Promise<ApiResult<PaginatedResult<CompetitionCollection>>> {
    return Request.getRequest<PaginatedResult<CompetitionCollection>>({
        ...params,
        target: links.admin().competitions.competitionCollections().collection,
    });
}

export async function updateCollection({
    chain,
    ...params
}: UpdateCollectionsParams): Promise<ApiResult<CompetitionCollection>> {
    return Request.patchRequest<CompetitionCollection>({
        ...params,
        target: links.admin().competitions.competitionCollections().single(params.slug, chain),
        settings: {
            ...params.settings,
        },
    });
}

export const callAdminGetCompetitionCollections = (params: GetCollectionsParams) =>
    apiReturnPaginatedResults<CompetitionCollection>(listCollections, params);

export const callUpdateCompetitionCollection = (params: UpdateCollectionsParams) =>
    apiReturnResults<CompetitionCollection>(updateCollection, params);
